import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import { ExecutionsInsertComponent } from "../AssistanceExecutions/ExecutionsInsertComponent";

export type TimeRegistrationModalProps = {
    isOpen: boolean;
    onClose: () => void;
    onComplete: () => void;
    assistanceId: number;
    equipmentId?: number;
    errorMessage?: string;
};

export const TimeRegistrationModal = (props: TimeRegistrationModalProps) => {
    return (
        <Dialog
            open={props.isOpen}
            maxWidth="md"
            fullWidth={true}
            onClose={props.onClose}
        >
            <DialogTitle>
                {"Registo de Tempos Necessário"}
            </DialogTitle>
            <DialogContent>
                {props.errorMessage && (
                    <div style={{ marginBottom: "20px", color: "#f44336" }}>
                        {props.errorMessage}
                    </div>
                )}
                <ExecutionsInsertComponent
                    assistanceId={props.assistanceId}
                    reloadExecutionsTable={props.onComplete}
                    isComplete={false}
                    onFetchExecutionsData={() => { }}
                    closeModalButtonIsVisible={true}
                    close={props.onClose}
                    equipmentId={props.equipmentId}
                />
            </DialogContent>
        </Dialog>
    );
};